/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Status_Export_CompleteInputs */

const en_video_export_status_export_complete = /** @type {(inputs: Video_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Complete`)
};

const fr_video_export_status_export_complete = /** @type {(inputs: Video_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation terminee`)
};

const de_video_export_status_export_complete = /** @type {(inputs: Video_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export abgeschlossen`)
};

const it_video_export_status_export_complete = /** @type {(inputs: Video_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione completata`)
};

const ru_video_export_status_export_complete = /** @type {(inputs: Video_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт завершен`)
};

const es_video_export_status_export_complete = /** @type {(inputs: Video_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación completa`)
};

const zh_cn2_video_export_status_export_complete = /** @type {(inputs: Video_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出完成`)
};

const ja_video_export_status_export_complete = /** @type {(inputs: Video_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポート完了`)
};

const hi_video_export_status_export_complete = /** @type {(inputs: Video_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात पूर्ण`)
};

const pt_pt2_video_export_status_export_complete = /** @type {(inputs: Video_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação concluída`)
};

/**
* | output |
* | --- |
* | "Export Complete" |
*
* @param {Video_Export_Status_Export_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_status_export_complete = /** @type {((inputs?: Video_Export_Status_Export_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Status_Export_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_status_export_complete(inputs)
	if (locale === "de") return de_video_export_status_export_complete(inputs)
	if (locale === "it") return it_video_export_status_export_complete(inputs)
	if (locale === "ru") return ru_video_export_status_export_complete(inputs)
	if (locale === "es") return es_video_export_status_export_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_status_export_complete(inputs)
	if (locale === "ja") return ja_video_export_status_export_complete(inputs)
	if (locale === "hi") return hi_video_export_status_export_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_status_export_complete(inputs)
	return en_video_export_status_export_complete(inputs)
});